module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-header-tesla-placeholder-1440x900-inact@2x.b96d8965.jpg";